import React, {
  useContext, useState, useEffect, useReducer,
} from 'react';
import PropTypes from 'prop-types';
import { MemberContext } from '../context';
import DetailTemplate from './DetailTemplate';
/* eslint-disable no-plusplus -- need */

/**
 * Card details component
 * @param {*} param
 */
const CardDetails = (props) => {
  const {
    fieldId,
    imgProps,
    assetDimension,
    cssProperties,
    setFormSubmissionPayload,
    formSubmissionPayload,
    showProductInfo,
    showSupplementaryCards,
    fieldValidation,
    setValidationErrors,
    validationErrors,
    fieldRank,
    setFocus,
  } = props;
  const memberContextVal = useContext(MemberContext);
  const [selectedCards, setSelectedCards] = useState({});
  const [selectedCardCount, setSelectedCardCount] = useState(0);
  const customInvalidMsg = fieldValidation?.customInvalidMsg || 'Please tick this box if you want to proceed';
  const minimumSelections = fieldValidation && fieldValidation.minimumSelections
    ? fieldValidation.minimumSelections : 1;
  const [validationErrState, dispatchErrState] = useReducer((prevState, payload) => ({ ...prevState, ...payload }), { validationErr: '', isValid: true });

  useEffect(() => {
    if (fieldValidation?.updatePayloadOnChange) {
      setFormSubmissionPayload({
        ...formSubmissionPayload,
        [fieldId]: Object.keys(selectedCards).length > 0 ? 'Yes' : 'No',
        elemId: null,
      });
    }
  }, [selectedCards]);

  const invalidHandler = () => {
    dispatchErrState({ validationErr: `${customInvalidMsg}`, isValid: false });
    if (fieldRank) {
      setValidationErrors({
        ...validationErrors,
        ...{ [fieldRank]: `${fieldId}` },
      });
      setFocus({ ...validationErrors, ...{ [fieldRank]: `${fieldId}` } });
    }
  };

  let cardCount = 1;
  return (
    <>
      <div id={`${fieldId}-validation-anchor`} className={`${fieldId} flex row`}>
        {
          memberContextVal.map((item, index) => (
            <React.Fragment key={`primary-${item.accountToken || index}`}>
              <div className={`primaryCard ${cssProperties.style}`}>
                <DetailTemplate
                  item={item}
                  imgProps={imgProps}
                  assetDimension={assetDimension}
                  cardCount={cardCount++}
                  setFormSubmissionPayload={setFormSubmissionPayload}
                  formSubmissionPayload={formSubmissionPayload}
                  setSelectedCards={setSelectedCards}
                  selectedCards={selectedCards}
                  showProductInfo={showProductInfo}
                  minimumSelections={minimumSelections}
                  invalidHandler={invalidHandler}
                  fieldValidation={fieldValidation}
                  selectedCardCount={selectedCardCount}
                  setSelectedCardCount={setSelectedCardCount}
                />
              </div>
              {showSupplementaryCards && item.supplementaryAccounts?.length > 0
                && item.supplementaryAccounts.map((suplmItem, suplmIndex) => (
                  <div
                    key={`suppl-${suplmItem.accountToken || suplmIndex}`}
                    className="supplmCards"
                    style={{ marginLeft: '100px' }}
                  >
                    <DetailTemplate
                      item={suplmItem}
                      imgProps={imgProps}
                      assetDimension={assetDimension}
                      cardCount={cardCount++}
                      setFormSubmissionPayload={setFormSubmissionPayload}
                      formSubmissionPayload={formSubmissionPayload}
                      setSelectedCards={setSelectedCards}
                      selectedCards={selectedCards}
                      minimumSelections={minimumSelections}
                      invalidHandler={invalidHandler}
                      fieldValidation={fieldValidation}
                      selectedCardCount={selectedCardCount}
                      setSelectedCardCount={setSelectedCardCount}
                    />
                  </div>
                ))}
            </React.Fragment>
          ))
        }
      </div>
      {/* Show custom invalid message if needed */}
      {validationErrState.validationErr && (
        <div id="alert-error" className="alert dls-color-warning pad-1-t col-md-12">
          <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
          <span>{validationErrState.validationErr}</span>
        </div>
      )}
    </>
  );
};
/* eslint-enable no-plusplus -- need */

CardDetails.propTypes = {
  fieldId: PropTypes.string,
  imgProps: PropTypes.objectOf(PropTypes.shape),
  assetDimension: PropTypes.string,
  setFormSubmissionPayload: PropTypes.func,
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  showProductInfo: PropTypes.bool,
  showSupplementaryCards: PropTypes.bool,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  setValidationErrors: PropTypes.func,
  validationErrors: PropTypes.objectOf(PropTypes.shape),
  fieldRank: PropTypes.number,
  setFocus: PropTypes.func,
};

export default CardDetails;
